import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes } from 'src/app/app-routes';
import { QUERY_PARAMS } from 'src/app/utils/constants';

export const requireQueryParamsGuard: CanActivateFn = (route, _state): true | UrlTree => {
	const router = inject(Router);

	const product = route.queryParamMap.get(QUERY_PARAMS.PRODUCT)?.trim();

	return product ? true : router.createUrlTree([AppRoutes.ERROR]);
};
